(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["fb-packs"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('fb-packs')) return;

    function findInput(el) {
      var scope = el.closest('.shopify-section') || document;
      return scope.querySelector('product-form-component input[name="quantity"]');
    }

    class FbPacks extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          var button = event.target.closest('[data-qty]');
          if (button) this.select(button.dataset.qty);
        });
        this.onQty = (event) => {
          var input = findInput(this);
          if (input && event.target === input) this.mark(String(input.value));
        };
        document.addEventListener('change', this.onQty);
        document.addEventListener('input', this.onQty);
      }

      disconnectedCallback() {
        document.removeEventListener('change', this.onQty);
        document.removeEventListener('input', this.onQty);
      }

      mark(qty) {
        this.querySelectorAll('[data-qty]').forEach(function (b) {
          b.setAttribute('aria-checked', b.dataset.qty === qty ? 'true' : 'false');
        });
      }

      select(qty) {
        this.mark(qty);
        var input = findInput(this);
        if (!input) return;
        input.value = qty;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    customElements.define('fb-packs', FbPacks);
  })();
  } catch(e) { console.error(e); }
})();

})();
